




import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import HandleGuestForm from "./HandleGuestForm.vue";
import { db, firestore } from "@/scripts/firebase";
import { JinroPlayerParams } from "@/services/paramstypes";
import { collectionName } from "@/services/collection-name";
import { DialogProgrammatic as Dialog } from "buefy";
import { JinroPlayerDocument } from "../../services/datatypes";

@Component({
  components: {},
})
export default class ChangeDisplayNameButton extends Vue {
  @Prop() readonly checkUpdatingDisplayName!: boolean;

  get userDisplayName(): string {
    if (!this.$store.state.user || !this.$store.state.user.displayName) {
      return "";
    }
    return this.$store.state.user.displayName;
  }
  get uid(): string {
    if (this.$store.state.firebaseUser) {
      return this.$store.state.firebaseUser.uid;
    }

    return "";
  }

  handleDisplayName() {
    Dialog.confirm({
      message: `「${this.userDisplayName}」 を変更しますか？`,
      cancelText: "キャンセル",
      confirmText: "変更する",
      onConfirm: () => this.dialogue(),
    });
  }
  dialogue() {
    Dialog.prompt({
      message: `「${this.userDisplayName}」 を変更します`,
      inputAttrs: {
        type: "text",
        placeholder: "新しい名前",
        value: "",
      },
      cancelText: "キャンセル",
      confirmText: "変更する",
      onConfirm: async (value) => this.checkDialogue(value),
    });
  }
  checkDialogue(value: string) {
    Dialog.confirm({
      message: `「${this.userDisplayName}」から「${value}」 に変更しますか？`,
      cancelText: "キャンセル",
      confirmText: "変更する",
      onConfirm: async () => await this.updateDisplayName(value),
    });
  }
  get buttonLabel(): string {
    let label = "";
    if (this.checkUpdatingDisplayName && this.isUpdatingJinroRoomPlayers) {
      label = `名前「${this.userDisplayName}」更新中`;
    } else {
      label = `名前「${this.userDisplayName}」を変更できます`;
    }

    return label;
  }

  get isUpdatingJinroRoomPlayers(): boolean {
    if (
      !this.$store.state.jinroRoomPlayers ||
      !this.$store.state.firebaseUser
    ) {
      return false;
    }
    const jinroRoomPlayers = this.$store.state.jinroRoomPlayers as Array<
      JinroPlayerDocument
    >;
    const uid = this.$store.state.firebaseUser.uid;
    const player = jinroRoomPlayers.find((py) => {
      return py.uid === uid;
    });
    if (!player) {
      return false;
    }

    return player.playerName !== this.userDisplayName;
  }

  async updateDisplayName(newDisplayName: string) {
    await db
      .collection(collectionName.users)
      .doc(this.uid)
      .set(
        {
          displayName: newDisplayName,
          timeUpdated: firestore.FieldValue.serverTimestamp(),
        },
        { merge: true }
      );
    return;
  }
}
